var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 31.333c8.468 0 15.333-6.865 15.333-15.333S24.468.667 16 .667.667 7.532.667 16v-.001C.676 24.463 7.535 31.323 16 31.333zM9.4 11.287a1.333 1.333 0 011.852-1.918l.033.033 4.479 4.479c.13.13.341.13.471 0l4.479-4.479a1.333 1.333 0 011.918 1.852l-.033.033-4.479 4.479a.333.333 0 000 .471l4.479 4.479a1.333 1.333 0 01-1.852 1.918l-.033-.033-4.479-4.479a.333.333 0 00-.471 0l-4.479 4.479A1.332 1.332 0 019.4 20.715l4.479-4.479a.333.333 0 000-.471z"
  })));
}
export default SvgDelete1;